module.exports = __webpack_public_path__ + "static/media/ADX.5075e419.svg";